// modules/admin/index.ts — Platik-IA
// Panel de administración. Solo accesible para rol 'admin'.

import { bus }      from '../../core/event-bus';
import { supabase } from '../../services/supabase';
import type { AdminAPI, AdminUser } from './contracts';

export async function initAdmin(): Promise<AdminAPI> {
  bus.emit('admin:ready');

  return {
    async listUsers(page = 0): Promise<AdminUser[]> {
      const PAGE_SIZE = 50;
      // Columnas explícitas: google_refresh_token_enc no es accesible para `authenticated`.
      const { data, error } = await supabase
        .from('users')
        .select('id, email, nickname, plan, gemini_key_enc, created_at, last_active_at')
        .order('created_at', { ascending: false })
        .range(page * PAGE_SIZE, (page + 1) * PAGE_SIZE - 1);

      if (error) throw new Error(error.message);

      return (data ?? []).map(u => ({
        id:           u.id,
        email:        u.email,
        nickname:     u.nickname,
        plan:         (u.plan ?? 'free') as 'free' | 'pro',
        hasGeminiKey: !!u.gemini_key_enc,
        createdAt:    u.created_at,
        lastActiveAt: u.last_active_at,
      }));
    },

    dispose() {},
  };
}
